var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 11.175.009 4.091c1.077 0 4.431.265 4.431.835s-.08 2.52.159 2.876c.635.953 2.879 2.563 4.12 2.579 1.88.024 5.048-2.909 4.565-4.939-.704-2.955-8.02-5.949-13.285-5.949v.005c-5.265 0-12.579 2.989-13.283 5.944-.483 2.029 2.685 4.963 4.565 4.939 1.241-.016 3.485-1.625 4.12-2.579.239-.356.159-2.307.159-2.876s3.369-.836 4.447-.836l-.005-4.089z"
  })));
};
export default SvgHangup;